export var ANALYTICS_CHANNEL = 'media';
export var COMPONENT_NAME = 'linkPicker';